// Global Types
import type {
  $WithRouter,
} from '@vroskus/library-navigation';
import type {
  $FullRegion,
  $Model,
} from 'common.data';

// Global Enums
import {
  webPages,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  scrollTop,
} from '@vroskus/library-helpers/dist/browser';
import {
  getRegionByRegionId,
  getRegionUrl,
} from 'common.helpers/dist/browser';
import config from '../../../config';

// Components
import Page from '../../layout/Page';
import Loader from '../../layout/Loader';
import BannersSection from '../../sections/RegattasPageSections/BannersSection';
import RegattasSection from '../../sections/RegattasPageSections/RegattasSection';

// Services
import Services from '../../../services';

// Types
import type {
  $ReducerState,
} from '../../../redux';
import type {
  $RedirectAction,
  $SetRegionAction,
} from '../../../redux/modules/main/actions';
import type {
  $Tags,
} from '../../../types';

export type $OwnProps = $WithRouter;

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = {
  redirect: $RedirectAction;
  setRegion: $SetRegionAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  initialised: boolean;
  item: $Model<'RegionSeason'> | null;
};

class RegattasPageView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      initialised: false,
      item: null,
    };
  }

  componentDidMount(): void {
    this.init();
  }

  getTags(): $Tags {
    const {
      main,
    } = this.props;
    const {
      item,
    } = this.state;

    const tags: $Tags = {
      title: 'Region',
      url: undefined,
    };

    if (item !== null) {
      const region: $FullRegion | undefined = _.find(
        main.regions,
        {
          id: item.RegionId,
        },
      );

      if (region) {
        tags.title = region.Name;

        tags.url = getRegionUrl({
          mainDomain: config.DOMAIN,
          RegionId: region.id,
          regions: main.regions,
        });
      }
    }

    return tags;
  }

  /* eslint-disable-next-line complexity */
  async init(): Promise<void> {
    const {
      location,
      main,
      params,
      redirect,
      setRegion,
    } = this.props;

    const {
      RegionId,
      regions,
    } = main;
    const {
      param1,
    } = params;

    try {
      scrollTop();

      if (param1) {
        const response = await Services.Api.getPageData({
          param1,
        });

        if (response !== null) {
          if (RegionId === null) {
            await setRegion({
              RegionId: response.RegionId,
            });
          }

          const pathname: string = `/${response.page}/${response.param1}`;

          redirect({
            pathname,
          });
        } else if (RegionId !== null) {
          const region = getRegionByRegionId({
            RegionId,
            regions,
          });

          const item: $Model<'RegionSeason'> | undefined = _.find(
            region.RegionSeasons,
            {
              Name: param1,
            },
          );

          if (item) {
            this.setState({
              initialised: true,
              item,
            });
          } else {
            redirect({
              pathname: '/',
            });
          }
        } else {
          redirect({
            pathname: '/',
          });
        }
      } else if (RegionId !== null) {
        const item = await Services.Api.getRegattasPageData({
          RegionId,
        });

        if (item !== null) {
          this.setState({
            initialised: true,
            item,
          });
        } else {
          redirect({
            pathname: '/',
          });
        }
      } else {
        redirect({
          pathname: '/regions',
          state: {
            from: location,
          },
        });
      }
    } catch (err) {
      const error = err as Error;

      ErrorLog.exception(error);
    }
  }

  render() {
    const {
      initialised,
      item,
    } = this.state;

    return (
      <Page
        id={webPages.regattasPage}
        tags={this.getTags()}
      >
        <Loader loading={!initialised}>
          {(item !== null && (
            <>
              <BannersSection RegionSeasonId={item.id} />
              <RegattasSection RegionSeasonId={item.id} />
            </>
          ))}
        </Loader>
      </Page>
    );
  }
}

export default RegattasPageView;
